import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import TickerStrip from "./components/TickerStrip";
import TrackingSection from "./components/TrackingSection";
import FactCheckSection from "./components/FactCheckSection";
import ReversalSection from "./components/ReversalSection";
import ResponsesSection from "./components/ResponsesSection";
import StatsSection from "./components/StatsSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <SiteHeader />
      <main>
        <HeroSection />
        <TickerStrip />
        <TrackingSection />
        <FactCheckSection />
        <ReversalSection />
        <ResponsesSection />
        <StatsSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}